var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33008 0V10H9.33008V0H8.33008ZM1.82065 5.76068C2.43874 4.49198 3.40996 3.41127 4.59829 2.65605L4.06192 1.81207C2.71962 2.66514 1.62234 3.88515 0.922346 5.32131C-1.2397 9.69141 0.525229 14.9915 4.89936 17.1565C9.26973 19.3196 14.5707 17.5548 16.7359 13.1802C18.7563 9.09825 17.3503 4.20536 13.5915 1.81229L13.0544 2.65584C16.3835 4.77527 17.6329 9.11362 15.8397 12.7366C13.9216 16.612 9.22258 18.1805 5.34295 16.2603C1.46755 14.3421 -0.100951 9.64313 1.81927 5.76349L1.82065 5.76068Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/signOut.b47638baa1c4091d22feef04b41b0c35.svg";
export { ForwardRef as ReactComponent };